exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._3pQtQ9wNKFkyj4LkvlT28P{padding:0 12px}html[dir] .lqyHCMN0Ds0F3dxL1ZTJM{border-radius:4px!important}.eOnPJN6oD1QWuGswJS6Oj{position:relative;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}._1IAdLqsrlKaf2tzxAVOs-9,.eOnPJN6oD1QWuGswJS6Oj{display:-webkit-box;display:-ms-flexbox;display:flex}._1IAdLqsrlKaf2tzxAVOs-9{color:\"[theme:white, default:#ffffff]\"!important}", ""]);
// Exports
exports.locals = {
	"newMessageButtonPadding": "_3pQtQ9wNKFkyj4LkvlT28P",
	"newMessageButtonWithIcon": "lqyHCMN0Ds0F3dxL1ZTJM",
	"newMessageButtonWithDropDown": "eOnPJN6oD1QWuGswJS6Oj",
	"newMessageButtonIcon": "_1IAdLqsrlKaf2tzxAVOs-9"
};